// extracted by mini-css-extract-plugin
export var ctaLink = "anchorLink-module--ctaLink--514c7";
export var outlineDark = "anchorLink-module--outlineDark--d4a88";
export var outlineLight = "anchorLink-module--outlineLight--840b2";